<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Subject Registration </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        @click="putnull" persistent-hint hint="Please Select Academic Year " />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv"
                        @click="putnull" persistent-hint hint="Please Select Standard " />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined @click="putnull" persistent-hint
                        hint="Please Select Division" />
                </v-col>

                <v-col sm="2" v-if="sel_ay_data && sel_std_data && div">
                    <v-btn class="mt-6 button" @click="getlearners()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2" v-if="learner != ''">
                    <v-btn class="ma-2 no-display " rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'SubjectRegistration')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <v-col cols="12" md="5" v-if="learner != ''">
                    <v-btn class="button" @click="registration()" :loading="com_sub_loader">Save Compulsory Subject
                        Registration</v-btn>
                </v-col>
                <v-col cols="12" md="5" v-if="learner != ''">
                    <v-btn class="button" @click="
              registration1();
              dialog1 = true;
            ">
                        Save Elective Subject Registration
                    </v-btn>
                </v-col>
            </v-row>
            <span v-if="this.learner == null && this.learner != ''">
                <v-row justify="center" class="p-0 m-0">
                    <strong>No learners for this academic year</strong>
                </v-row>
            </span>
            <span v-if="learner != '' && learner != null">
                <div id="my-table-id">
                    <v-data-table v-if="learner!=''" dense :headers="headers1" :items="bookList1" :search="search"
                        class="elevation-1 mytable" @current-items="getFiltered" :items-per-page="-1">
                        <template v-slot:item.subject="{ item }">
                            <span v-if="item.subject != '0'">
                                <v-btn @click="getcourse(item.subject_id)" class="btn-css btn">
                                    {{ item.subject }}
                                </v-btn>
                            </span>
                            <v-btn v-else color="red" text> Not Registered </v-btn>

                            <v-tooltip top color="gray">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" color="gray"
                                        @click="saveSubjectRegistartionIndividual(item.lid)" class="btn-css btn">
                                        <v-icon>mdi-plus-circle-multiple-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>
                                    Save Individual Compulsary Subject Registartion
                                </span>
                            </v-tooltip>


                        </template>

                        <template v-slot:top class="pb-5">
                            <v-row justify="center" align="center">
                                <tr class="t-row">
                                    <div>
                                        <th>
                                            <v-row>
                                                <span v-for="header in headers1" :key="header.text">
                                                    <span v-if="filters.hasOwnProperty(header.value)">
                                                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                            rounded dense outlined color="#0F2027" :label="header.text"
                                                            multiple clearable :items="columnValueList(header.value)"
                                                            v-model="filters[header.value]"></v-autocomplete>
                                                    </span>
                                                </span>
                                            </v-row>
                                        </th>
                                    </div>
                                </tr>
                            </v-row>
                        </template>
                    </v-data-table>
                </div>
            </span>
        </v-card>

     <v-dialog v-model="dialog" persistent max-width="1200px">
  <v-card>
    <v-toolbar class="toolbar" flat dense>
      <v-toolbar-title><strong>Registered Courses</strong></v-toolbar-title>
    </v-toolbar>

    <v-col cols="12">
      <v-card class="box">
        <span v-if="filteredCourses.length">
     <v-data-table
  dense
  :headers="headers"
  :items="filteredCourses"
  :search="search"
  class="elevation-1 mytable"
  :items-per-page="-1"
>
  <template v-slot:body="{ items }">
    <tbody>
      <tr v-for="(item, index) in items" :key="item.courseOfferingLearner">
        <td>{{ index + 1 }}</td>
        <td>{{ item.crs_name }}</td>
        <td class="text-center">{{ item.crs_type }}</td>
        <td class="text-center">
          <center v-if="item.delete === 'NO'">
            <v-tooltip top color="gray">
              <template v-slot:activator="{ on, attrs }">
                <v-avatar size="33">
                  <v-icon class="mr-2" v-bind="attrs" v-on="on" color="gray">delete</v-icon>
                </v-avatar>
              </template>
              <span>This scheme is offer so you cannot delete it.</span>
            </v-tooltip>
          </center>
          <center v-else>
            <v-avatar size="33" class="delete-avatar">
              <v-icon
                class="mr-2 delete-v-icon"
                color="red"
                @click="deletereg(item.courseOfferingLearner)"
              >delete</v-icon>
            </v-avatar>
          </center>
        </td>
      </tr>
    </tbody>
  </template>
</v-data-table>

        </span>

        <v-row justify="center">
          <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
        </v-row>
      </v-card>
    </v-col>
  </v-card>
</v-dialog>

        <v-dialog v-model="dialog1" persistent max-width="1200px">
            <v-card>
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Elective Subject Registration </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box">
                        <v-row justify="center" v-if="course_list && course_list.length > 0">
                            <span v-for="crs in course_list" :key="crs.crs_id" class="mr-4">
                                <input type="checkbox" class="radiospace" v-model="crs_ids" :value="crs.crs_id" />
                                {{ crs.crs_name }}
                            </span>
                        </v-row>
                        
                        <span v-if="crs_ids.length > 0">
                            <v-row class="p-0 m-0">
                                <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                                <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                                    <v-text-field class="search" v-model="search" append-icon="mdi-magnify"
                                        label="Search in table" single-line hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <v-data-table v-model="selectedTasks" :single-select="singleSelect" show-select dense
                                :headers="headers2" :items="learner_list" item-key="lid" :search="search"
                                class="elevation-1" :items-per-page="-1"> </v-data-table>
                        </span>
                    </v-card>
                    <v-row justify="center">
                        <v-btn rounded class="button" @click="electiveregistration()">Save</v-btn>
                        <v-btn rounded class="button" @click="dialog1 = false">Close</v-btn>
                    </v-row>
                </v-col>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_delete_que" persistent max-width="500px">
            <v-card>
                <v-container>
                    <v-card class="box">
                        <input type="hidden" v-model="deleteItem.delete_id" />
                        <strong>Are you sure you want Delete This Subject Registartion??</strong>
                        <v-row justify="center">
                            <v-btn class="button" text @click="dialog_delete_que = false">No</v-btn>
                            <v-btn class="button" text @click="deleteregistartion()">Yes</v-btn>
                        </v-row>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                fetch_loader: false,
                com_sub_loader: false,
                overlay: false,
                selected: [],
                snackbar: false,
                pagination: {
                    sortBy: "name",
                },
                dialog: false,
                dialog1: false,
                course_list: [],
                crs_ids: [], 
                search: "",
                dialog_delete_que: false,
                deleteItem: {
                    delete_id: "",
                },
                crs_list: [],
                snackbar_msg: "",
                color: "",
                singleSelect: false,
                selectedTasks: [],
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                inst_list: null,
                learner: [],
                filterArr: [],
                filters: {
                    std: [],
                    div: [],
                    registration_number: [],
                    learner_list: [],
                },
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno1",
                    },
                    {
                        text: "Subject",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Subject Type",
                        align: "center",
                        sortable: false,
                        value: "crs_type",
                    },
                    {
                        text: "Delete",
                        align: "center",
                        sortable: false,
                        value: "delete",
                    },
                ],
                table_fields: {
                    "Sr. No": "srno",
                    "Academic Year": "ay",
                    Standard: "std",
                    Division: "div",
                    "PRN. Number": "registration_number",
                    "Roll No": "rollno",
                    "Student Name": "name",

                    Subject: "subject",
                },
                headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "ay",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "div",
                    },
                    {
                        text: "PRN No.",
                        align: "center",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        align: "center",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        align: "center",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "Subject",
                        align: "center",
                        sortable: false,
                        value: "subject",
                    },
                ],
                headers2: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "ay",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "div",
                    },
                    {
                        text: "PRN No.",
                        align: "center",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        align: "center",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        align: "center",
                        sortable: false,
                        value: "name",
                    },
                ],
            };
        },
        computed: {
           filteredCourses() {
    return this.crs_list.filter(course => course.crs_name.toLowerCase() !== "na:na");
  },
            bookList1() {
                return this.learner.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Academic Year</th>
      <th>Standard</th>
      <th>Division</th>
      <th>PRN No.</th>
      <th>Roll No</th>
      <th>Name</th>
      <th>Subject</th>
      
      
    </tr>`;

  this.bookList1.forEach((item, index) => {
    tab_text += `
    <tr>
                <td>${index + 1}</td>
                <td>${item.ay || ''}</td>
                <td>${item.std || ''}</td>
                <td>${item.div || ''}</td>
                <td>${item.registration_number || ''}</td>
                <td>${item.rollno || ''}</td>
                <td>${item.name || ''}</td>
                <td>${item.subject || ''}</td>
            </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
            deletereg(courseOfferingLearner) {
                this.dialog_delete_que = true;
                this.deleteItem.delete_id = courseOfferingLearner;
            },
            deleteregistartion() {
                const formData = {
                    courseOfferingLearner: this.deleteItem.delete_id,
                };
                axios
                    .post("/examination/deleteregistartion", formData)
                    .then((res) => {
                        if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", "Subject Registration Deleted successfully");
                            this.getlearners();
                            this.dialog_delete_que = false;
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                        this.dialog_delete_que = false;
                        this.dialog = false;
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
            electiveregistration() {
                if (this.selectedTasks == "") {
                    this.showSnackbar("#b71c1c", "Please select learners");
                    return;
                }
                if (this.crs_ids.length === 0) {
                    this.showSnackbar("#b71c1c", "Please select at least one elective subject");
                    return;
                }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    crs_ids: this.crs_ids,
                    student_id: this.selectedTasks,
                };
                axios
                    .post("/Examination/electiveSubjectRegistration", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Elective Subject Registration Done Successfully");
                            this.getlearners();
                            this.dialog1 = false;
                        }
                        this.dialog1 = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); 
                        this.dialog1 = false;
                    })
                    .finally(() => {
                        this.crs_ids  = [] 
                        this.selectedTasks = []
                    });
            },
            registration1() {
                this.overlay = true;
                let div = this.div.div_id;
                if (this.div.div_id) {
                    div = this.div.div_id;
                } else {
                    div = this.div;
                }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    division: div,
                    type:"elective"
                };

                axios
                    .post("/Examination/subjectRegistration", data)
                    .then((res) => {
                        this.course_list = res.data.course_list;
                        this.learner_list = res.data.learner;
                        this.overlay = false;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            saveSubjectRegistartionIndividual(lid){
            //  alert(lid)
              this.com_sub_loader = true;
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    lid: lid,
                };

                axios
                    .post("/Examination/saveSubjectRegistartionIndividual", data)
                    .then((res) => {
                        this.course_list = res.data.course_list;
                       // this.learner_list = res.data.learner;
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Compulsory Subject Registration Done Successfully");
                            this.getlearners();
                            this.com_sub_loader = false;
                        }
                        if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "Already Register..."); // show snackbar
                            this.getlearners();
                            this.com_sub_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.com_sub_loader = false;
                    })
                    .finally(() => {
                        this.com_sub_loader = false;
                    });
            },
            registration() {
                this.com_sub_loader = true;
                let div = this.div.div_id;
                if (this.div.div_id) {
                    div = this.div.div_id;
                } else {
                    div = this.div;
                }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    division: div,
                    type:"compulsary"
                };

                axios
                    .post("/Examination/subjectRegistration", data)
                    .then((res) => {
                        this.course_list = res.data.course_list;
                        this.learner_list = res.data.learner;
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Compulsory Subject Registration Done Successfully");
                            this.getlearners();
                            this.com_sub_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.com_sub_loader = false;
                    })
                    .finally(() => {
                        this.com_sub_loader = false;
                    });
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.learner.map((d) => d[val]);
            },
            columnValueList1(val) {
                return this.learner_list.map((d) => d[val]);
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            putnull() {
                this.learner = [];
            },
            getlearners() {
                this.crs_ids = [] 
                this.fetch_loader = true;
                let ay;
                if (this.sel_ay_data.ay_id) {
                    ay = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay = this.sel_ay_data.id;
                }
                let div = this.div.div_id;
                if (this.div.div_id) {
                    div = this.div.div_id;
                } else {
                    div = this.div;
                }
                const formData = {
                    ay: ay,
                    standard: this.sel_std_data.std_id,
                    division: div,
                };
                axios
                    .post("/Examination/getlearners", formData)
                    .then((res) => {
                        // if (res.data.learner.length != 0) {
                            this.learner = res.data.learner;
                            this.fetch_loader = false;
                        // } else {
                        //     this.learner = null;
                        //     this.fetch_loader = false;
                        // }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); 
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        ay = null;
                        this.fetch_loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getcourse(subject_id) {
                const data = {
                    subject_id: subject_id,
                };
                axios
                    .post("/Examination/getcourse", data)
                    .then((res) => {
                        this.crs_list = res.data.crs_list;

                        this.dialog = true;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }

    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
</style>